import api from './functions/api';
import { verifyData } from './functions/verify-response';

export async function checkLogin(): Promise<object | undefined> {
  return api.get('/checkLogin/').then(response => {
    return verifyData(response);
  }).catch(error => {
    return verifyData(error.response);
  });
} 